export const validMessage = {
  required: "Este campo es requerido",
  email: "Debe ingresa un correo electrónico válido.",
};
